/**
 * @desc 收藏挂牌商品
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CollectListingParameter = {
  id?: string
}

const method = 'POST'
const url = '/trade/mall/listing/collection'

export const collectListingApi = (
  params?: CollectListingParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

collectListingApi.method = method
collectListingApi.url = url
